import React, { memo } from "react";

const RequestImageGallery = memo(({ images }) => (
    <div className="scroll-container mt-3">
        {images?.length > 0 ? (
            images.map((image, index) => (
                <img
                    src={image?.ftm_request_image_path}
                    alt={`Image_${index + 1}`}
                    key={index}
                    className="mb-1"
                />
            ))
        ) : (
            <p className="text-center pt-3">No images found</p>
        )}
    </div>
));

export default RequestImageGallery;